export const EMAILS = {
  pergaminHelp: 'help@pergam.in',
} as const;
